export default __webpack_public_path__ + "static/media/DINNextLTW23-Bold.9902e6b3.ttf";